<kt-portlet>
    <kt-portlet-header
            [title]="getComponentTitle()"
            [class]="'kt-portlet-head--lg'"
            [tooltipTitle]="'TOOLTIP.AUDIT_TRAIL.FORM'+(auditTrail && auditTrail.id > 0 ? '_EDIT':'')+'.TITLE' | translate"
            [tooltipDesc]="'TOOLTIP.AUDIT_TRAIL.FORM'+(auditTrail && auditTrail.id > 0 ? '_EDIT':'')+'.DESCRIPTION' | translate"
            [viewLoading$]="loading$">
        <ng-container ktPortletTools>
            <a class="btn mr-2" mat-raised-button
                (click)="goBack()"
               [matTooltip]="'GENERAL.TOOLTIP.BACK' | translate:{
                    back_page: ('AUDIT_TRAIL.FORM.TITLE.LIST' | translate)
                } "
            >
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">
                    {{ 'GENERAL.BUTTON.BACK' | translate }}
                </span>
            </a>
            <a href="javascript:;" class="btn btn-success mr-2" color="submit" [hidden]="readOnly"
               (click)="auditTrailSaveNotification()"
               [disabled]="!isFormValid()"
               mat-raised-button
               [matTooltip]="'GENERAL.TOOLTIP.SAVE' | translate">
                <span class="kt-hidden-mobile">
                    {{ 'GENERAL.BUTTON.SAVE' | translate }}
                </span>
            </a>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <form class="kt-form" [formGroup]="auditTrailForm">
            <div class="kt-portlet-body body_padding_top_zero">

                <!--<div class="kt-portlet-body-progress">-->
                    <!--<mat-spinner [diameter]="20"></mat-spinner>-->
                <!--</div>-->
                <div class="mb-4" *ngIf="auditTrail.notes">
                    *{{auditTrail.notes}}
                </div>

                <kt-alert *ngIf="hasFormErrors" [type]="'warn'" [duration]="30000" [showCloseButton]="true" (close)="onAlertClose($event)">
                    {{ 'GENERAL.MESSAGE.FORM_WARNING' | translate }}
                </kt-alert>

                <div class="form-group kt-form-group row">
                    <div class="col-md-12 kt-margin-bottom-20-mobile">
                        <h5 class="my-3 text-mad text-uppercase">
                            {{ 'AUDIT_TRAIL.FORM.FIELD.GENERAL.SECTION_TITLE' | translate }}
                        </h5>
                        <hr class="active">
                    </div>

                    <div class="col-lg-4 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <span (click)="picker.open()">
                            <input matInput [matDatepicker]="picker"
                                   [placeholder]="'AUDIT_TRAIL.FORM.FIELD.GENERAL.DATE_OF_INTERACTION.PLACEHOLDER' | translate"
                                   formControlName="interaction_date"
                                   [value]="'hello'"/>
                            </span>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <button mat-button *ngIf="!readOnly && this.auditTrailForm.controls.interaction_date.value" matSuffix mat-icon-button
                                    [matTooltip]="'GENERAL.TOOLTIP.CLEAR' | translate"
                                    (click)="clearDate(this.auditTrailForm.controls.interaction_date)">
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select
                                    [placeholder]="'AUDIT_TRAIL.FORM.FIELD.GENERAL.TOE.PLACEHOLDER' | translate"
                                    formControlName="terms_of_engagement_id" (selectionChange)="changeClient($event)" #singleSelectToe>
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="filterCtrl"
                                                           [placeholderLabel]="'GENERAL.PLACEHOLDER.SEARCH' | translate"
                                                           [noEntriesFoundLabel]="'GENERAL.MESSAGE.NOT_FOUND' | translate:{
                                                               entry: ('AUDIT_TRAIL.FORM.FIELD.GENERAL.TOE.NAME' | translate)
                                                           } ">

                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let _data of filteredSelectionModels | async" [value]="_data.id">
                                    {{_data.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{field: ('AUDIT_TRAIL.FORM.FIELD.GENERAL.TOE.NAME' | translate)} "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select
                                    [placeholder]="'AUDIT_TRAIL.FORM.FIELD.GENERAL.CLIENT.PLACEHOLDER' | translate"
                                    class="client" formControlName="client_id" id="client">
                                <mat-option *ngFor="let client of clients" [value]="client.id">
                                    {{client.type == 'Company' ? client.name : client.name + ' ' + client.last_name}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{field: ('AUDIT_TRAIL.FORM.FIELD.GENERAL.CLIENT.NAME' | translate)} "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-12 kt-margin-bottom-10-mobile mt-4" *ngIf="this.auditTrailForm.controls.terms_of_engagement_id.value != 0">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select
                                    [placeholder]="'AUDIT_TRAIL.FORM.FIELD.GENERAL.TARGET_PROPERTY.PLACEHOLDER' | translate"
                                    formControlName="asset_class_id">
                                <mat-option *ngFor="let assetClass of assetClasses" [value]="assetClass.id">{{assetClass.name}}</mat-option>
                            </mat-select>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{field: ('AUDIT_TRAIL.FORM.FIELD.GENERAL.TARGET_PROPERTY.NAME' | translate)} "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group kt-form-group row section-margin-top-60">
                    <div class="col-md-12 kt-margin-bottom-20-mobile">
                        <h5 class="my-3 text-mad text-uppercase">
                            {{ 'AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.SECTION_TITLE' | translate }}
                        </h5>
                        <hr class="active">
                    </div>

                    <div class="col-lg-4 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select
                                    [placeholder]="'AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.INTERACTION_TYPE.PLACEHOLDER' | translate"
                                    formControlName="interaction_type_id" #singleSelectInteractionType>
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="filterCtrlInteractionType"
                                                           [placeholderLabel]="'GENERAL.PLACEHOLDER.SEARCH' | translate"
                                                           [noEntriesFoundLabel]="'GENERAL.MESSAGE.NOT_FOUND' | translate:{
                                                            entry: ('AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.INTERACTION_TYPE.NAME' | translate)
                                                        } ">

                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let _data of filteredInteractionTypes | async" [value]="_data.id">
                                    {{_data.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.INTERACTION_TYPE.NAME' |  translate)
                                    } "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput
                                   [placeholder]="'AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.LOCATION.PLACEHOLDER' | translate" formControlName="location"
                            />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select
                                    [placeholder]="'AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.EXPECTED_IMPACT_ON_VAL.PLACEHOLDER' | translate"
                                    formControlName="impact_on_valuation" #singleSelectValuation>
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="filterCtrlValuation"
                                                           [placeholderLabel]="'GENERAL.PLACEHOLDER.SEARCH' | translate"
                                                           [noEntriesFoundLabel]="'GENERAL.MESSAGE.NOT_FOUND' | translate:{
                                                            entry: ('AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.EXPECTED_IMPACT_ON_VAL.NAME' | translate)
                                                            }">

                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let _data of filteredValuations | async" [value]="_data">
                                    {{_data}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.EXPECTED_IMPACT_ON_VAL.NAME' |  translate)
                                    } "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group kt-form-group row">
                    <div class="col-lg-12 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput rows="4"
                                      [placeholder]="'AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.INTERACTION_DESC.PLACEHOLDER' | translate"
                                      formControlName="interaction_description"></textarea>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.INTERACTION_DESC.NAME' |  translate)
                                    } "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group kt-form-group row">
                    <div class="col-lg-12 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput rows="4"
                                      [placeholder]="'AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.EXP_ACTION_MIT_STRA.PLACEHOLDER' | translate"
                                      formControlName="mitigation_strategy"></textarea>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.EXP_ACTION_MIT_STRA.NAME' |  translate)
                                    } "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group kt-form-group row">
                    <div class="col-lg-12 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput rows="4"
                                      [placeholder]="'AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.INPUT.PLACEHOLDER' | translate"
                                      formControlName="mitigation_strategy1"></textarea>
                            <mat-icon
                                    matSuffix
                                    class="cursor-pointer"
                                    (click)="$event.stopPropagation();"
                                    [popoverTitle]="'TOOLTIP.AUDIT_TRAIL.FORM_FIELD.INPUT.TITLE' | translate"
                                    [ngbPopover]="'TOOLTIP.AUDIT_TRAIL.FORM_FIELD.INPUT.DESCRIPTION' | translate">help
                            </mat-icon>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('AUDIT_TRAIL.FORM.FIELD.INTERACTION_DETAIL.INPUT.NAME' |  translate)
                                    } "
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group kt-form-group row section-margin-top-60">
                    <div class="col-md-12 kt-margin-bottom-20-mobile">
                        <h5 class="my-3 text-mad text-uppercase">
                            {{ 'AUDIT_TRAIL.FORM.FIELD.PARTICIPANTS.SECTION_TITLE' | translate }}
                        </h5>
                        <hr class="active">
                    </div>
                    <div class="col-md-12 kt-margin-bottom-20-mobile">
                        <kt-participant-list
                                [agencyName]="agencyName"
                                [clientName]="clientName"
                                [toeSelected]="toeSelected"
                                [participantsSubject]="participantsSubject"
                                [atLeastOneParticipant$]="atLeastOneParticipant$"
                                [readOnly]="readOnly"
                                [agencyId]="agencyId$"
                                [clientId]="clientId$"
                                [toeId]="toeId$"
                                [readOnly]="readOnly"
                        >
                        </kt-participant-list>
                    </div>
                </div>

                <div class="form-group kt-form-group row section-margin-top-60">
                    <div class="col-md-12 kt-margin-bottom-10-mobile">
                        <h5 class="my-3 text-mad text-uppercase">
                            {{ 'AUDIT_TRAIL.FORM.FIELD.ATTACHMENTS.SECTION_TITLE' | translate }}
                            <mat-icon
                                    class="cursor-pointer"
                                    (click)="$event.stopPropagation();"
                                    [popoverTitle]="'AUDIT_TRAIL.FORM.POP_OVER.UPLOAD_FILE.TITLE' | translate"
                                    [ngbPopover]="'AUDIT_TRAIL.FORM.POP_OVER.UPLOAD_FILE.DESCRIPTION' | translate">help
                            </mat-icon>
                        </h5>
                        <hr class="active">
                    </div>
                    <div class="col-md-12 kt-margin-bottom-20-mobile">
                        <kt-upload-file
                                [filesOnEditMode]="auditTrail.audit_file"
                                [readOnly]="readOnly"
                                folderOnEditMode=""
                                [fileType]="fileType"
                                [descriptionField]="true"
                                [parentForm]="'audit'">

                        </kt-upload-file>
                    </div>
                </div>
            </div>
        </form>
    </kt-portlet-body>
</kt-portlet>